// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LogAnalyticsSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="LogAnalyticsSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M4.127 10.96a.3.3 0 0 0 .11.075.3.3 0 0 0 .135.028h10.872l-.007.042-.01.061a6.8 6.8 0 0 1-.459 1.533h-2.6c-.271 0-.495.2-.495.447v1.23c0 .245.224.446.496.446h1.152a6.93 6.93 0 0 1-4.907 2.025C4.595 16.847 1.5 13.781 1.5 10s3.095-6.847 6.913-6.847a6.93 6.93 0 0 1 4.732 1.855l.014.013a7 7 0 0 1 .179.174L13.3 5.199H7.29c-.258 0-.467.19-.467.421v1.282a.4.4 0 0 0 .17.325.5.5 0 0 0 .296.096h7.488l.008.016a6.4 6.4 0 0 1 .45 1.55l.008.049H4.372a.347.347 0 0 0-.346.347v1.43a.35.35 0 0 0 .101.245m1.636 2.152-.002.047v1.202q0 .024.002.047a.45.45 0 0 0 .058.18v.001a.5.5 0 0 0 .436.233h4.07a.5.5 0 0 0 .44-.241l.004-.01a.45.45 0 0 0 .05-.21V13.16l-.001-.047a.5.5 0 0 0-.063-.189.5.5 0 0 0-.43-.225h-4.07a.5.5 0 0 0-.442.244.5.5 0 0 0-.052.17" />
      <path d="M16.862 14.51a1 1 0 0 0 .346-.75c0-.585-.529-1.061-1.176-1.061H14.77l-.008.018a5 5 0 0 1-.129.278l-.028.055-.021.042-.003.006L14.58 13.1l-.063.119a7 7 0 0 1-.346.574 7 7 0 0 1-.848 1.03h2.709a1.24 1.24 0 0 0 .831-.313" />
      <path d="M18.5 10a1 1 0 0 1-.346.75 1.24 1.24 0 0 1-.832.312h-2.078a4 4 0 0 0 .053-.364 5.8 5.8 0 0 0-.029-1.597V9.1q-.011-.083-.024-.162h2.079C17.97 8.938 18.5 9.415 18.5 10" />
      <path d="M16.317 7.01a1 1 0 0 0 .346-.75c0-.584-.53-1.061-1.177-1.061 0 0-2.105-.009-2.148-.004a6.9 6.9 0 0 1 1.356 1.939l.008.018v.001l.076.17.708-.001a1.24 1.24 0 0 0 .831-.312" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LogAnalyticsSignetIcon = /* @__PURE__ */ Object.assign(
  LogAnalyticsSignetIconComponent,
  { displayName: 'LogAnalyticsSignetIcon' },
);
